export const BOARD_SIZE = 15;
export const Player = {
    black: true,
    white: false,
};
export const isBlack = (player) => player;
export const isWhite = (player) => !player;
export const opponent = (player) => !player;
const rowKinds = ["two", "sword", "three", "four", "five", "overline"];
export const RowKind = {
    two: "two",
    sword: "sword",
    three: "three",
    four: "four",
    five: "five",
    overline: "overline",
};
//# sourceMappingURL=fundamentals.js.map